const ServiceHelper = {
    install(Vue) {
        Vue.prototype.$cache = {
            vm: Vue.prototype,
            expire: 14400000, // 1000 * 60 * 60 * 4 = 4hrs

            dataGet(key, path) {
                return new Promise((resolve, reject) => {
                    const $store = this.vm.$ls; // Get the data from cache.
                    // $store.removeSession(key);
                    let data = $store.get(key);
                    if (data && !window.JMPMustRefresh) resolve(data); // Cached.
                    else { // From server.
                        Vue.axios
                            .get(path, { limit: 500 })
                            .then(response => {
                                if (response.data.s) {
                                    data = response.data.d;
                                    $store.set(key, data, this.expire);
                                    resolve(data);
                                }
                                else {
                                    reject(Error(response.data.m));
                                }
                            })
                            .catch(err => {
                                reject(err);
                            });
                    }
                });
            },

            dataPost(key, path, postData) {
                return new Promise((resolve, reject) => {
                    const $store = this.vm.$ls; // Get the data from cache.
                    // $store.removeSession(key);
                    let data = $store.get(key);
                    if (data && !window.JMPMustRefresh) resolve(data); // Cached.
                    else { // From server.
                        Vue.axios
                            .post(path, postData)
                            .then(response => {
                                if (response.data.s) {
                                    data = response.data.d;
                                    $store.set(key, data, this.expire);
                                    resolve(data);
                                }
                                else {
                                    reject(Error(response.data.m));
                                }
                            })
                            .catch(err => {
                                reject(err);
                            });
                    }
                });
            },

            /* accessory() { return this.dataGet('m_accessory', '/accessory'); },
            applicationStatus() { return this.dataGet('m_applicationstatus', '/applicationstatus'); }, */
        };
    }
};

export default ServiceHelper;



// WEBPACK FOOTER //
// ./src/util/CacheHelper.js